(function ($) {
  Drupal.behaviors.stopOtherVideos = {
    attach: function (context, settings) {
      $('.nerivio-image video', context).on('play', function () {
        // Pause all other videos when a video starts playing
        $('.nerivio-image video').not(this).each(function () {
          this.pause();
        });
      });
    }
  };
})(jQuery);
